﻿

	 import { Moment } from 'moment';
	 import { SearchFilter } from '@models/search-filters/SearchFilter';
    
    export class ChatMessageSearchFilter extends SearchFilter {
        
        
        /**
        * Get all records from date
        */
        fromDate?: Moment | null;
    }
